<template>
  <div class="plan">
    <div class="max">
      <h2>預售新成屋方案內容</h2>
      <div class="card-block">
        <div class="card" v-for="(item,index) in plan" :key="index">
          <div class="card-header">
            <h2>{{item.name}}</h2>
          </div>
          <div class="card-body">
            <div
              v-if="item.project && item.project.length > 0"
              class="project-list"
            >
            <div class="project-container">
              <div
                v-for="(project,index) in item.project"
                class="project"
                :key="index"
              >
                <div>
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_60_691" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
                    <rect x="0.5" y="0.222656" width="24" height="24" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_60_691)">
                    <path d="M11.1 14.0227L8.95 11.8727C8.76667 11.6893 8.53333 11.5977 8.25 11.5977C7.96667 11.5977 7.73333 11.6893 7.55 11.8727C7.36667 12.056 7.275 12.2893 7.275 12.5727C7.275 12.856 7.36667 13.0893 7.55 13.2727L10.4 16.1227C10.6 16.3227 10.8333 16.4227 11.1 16.4227C11.3667 16.4227 11.6 16.3227 11.8 16.1227L17.45 10.4727C17.6333 10.2893 17.725 10.056 17.725 9.77266C17.725 9.48932 17.6333 9.25599 17.45 9.07266C17.2667 8.88932 17.0333 8.79766 16.75 8.79766C16.4667 8.79766 16.2333 8.88932 16.05 9.07266L11.1 14.0227ZM12.5 22.2227C11.1167 22.2227 9.81667 21.9602 8.6 21.4352C7.38333 20.9102 6.325 20.1977 5.425 19.2977C4.525 18.3977 3.8125 17.3393 3.2875 16.1227C2.7625 14.906 2.5 13.606 2.5 12.2227C2.5 10.8393 2.7625 9.53932 3.2875 8.32266C3.8125 7.10599 4.525 6.04766 5.425 5.14766C6.325 4.24766 7.38333 3.53516 8.6 3.01016C9.81667 2.48516 11.1167 2.22266 12.5 2.22266C13.8833 2.22266 15.1833 2.48516 16.4 3.01016C17.6167 3.53516 18.675 4.24766 19.575 5.14766C20.475 6.04766 21.1875 7.10599 21.7125 8.32266C22.2375 9.53932 22.5 10.8393 22.5 12.2227C22.5 13.606 22.2375 14.906 21.7125 16.1227C21.1875 17.3393 20.475 18.3977 19.575 19.2977C18.675 20.1977 17.6167 20.9102 16.4 21.4352C15.1833 21.9602 13.8833 22.2227 12.5 22.2227Z" fill="#3B7085"/>
                    </g>
                  </svg>
                  <p>
                    {{ project }}
                  </p>
                </div>
                <div v-if="item.project.length > 1 && index === 0">+</div>
              </div>
            </div>
            </div>
            <div class="intro" v-html="item.intro"></div>
          </div>
          <div class="card-footer" v-if="item.footer">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_60_715" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
              <rect y="0.222656" width="20" height="20" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_60_715)">
              <path d="M10.0001 14.6188L6.54176 16.7021C6.38898 16.7994 6.22926 16.841 6.06259 16.8271C5.89593 16.8133 5.75009 16.7577 5.62509 16.6605C5.50009 16.5633 5.40287 16.4417 5.33343 16.2959C5.26398 16.1501 5.25009 15.9869 5.29176 15.8063L6.20843 11.8688L3.14593 9.22298C3.00704 9.09798 2.92023 8.95562 2.88551 8.7959C2.85079 8.63618 2.86121 8.47993 2.91676 8.32715C2.97232 8.17437 3.05565 8.04937 3.16676 7.95215C3.27787 7.85493 3.43065 7.79243 3.62509 7.76465L7.66676 7.41048L9.22926 3.70215C9.29871 3.53548 9.40634 3.41048 9.55218 3.32715C9.69801 3.24382 9.84732 3.20215 10.0001 3.20215C10.1529 3.20215 10.3022 3.24382 10.448 3.32715C10.5938 3.41048 10.7015 3.53548 10.7709 3.70215L12.3334 7.41048L16.3751 7.76465C16.5695 7.79243 16.7223 7.85493 16.8334 7.95215C16.9445 8.04937 17.0279 8.17437 17.0834 8.32715C17.139 8.47993 17.1494 8.63618 17.1147 8.7959C17.08 8.95562 16.9931 9.09798 16.8543 9.22298L13.7918 11.8688L14.7084 15.8063C14.7501 15.9869 14.7362 16.1501 14.6668 16.2959C14.5973 16.4417 14.5001 16.5633 14.3751 16.6605C14.2501 16.7577 14.1043 16.8133 13.9376 16.8271C13.7709 16.841 13.6112 16.7994 13.4584 16.7021L10.0001 14.6188Z" fill="white"/>
              </g>
            </svg>
            <h3>
              {{ item.footer }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.plan{
  @include basic-flex(column);
  padding: 50px 5% 80px 5% !important;
  background-color: #f9f9f9;
  .max{
    width: 100%;
    max-width: 1350px;
    @include basic-flex(column);
    h2{
      font-size: 24px;
      line-height: 24px;
      font-weight: 700;
    }
    h6{
      @include h6(#333);
      @include m-spacing(10px,0px);
    }
    .card-block{
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      width: 100%;
      @include m-spacing(20px, 5%);
      // flex-direction: row;
      .card{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(50% - 5px);
        border-radius: 10px;
        overflow: hidden;
        background-color: white;
        padding: 24px;
        .card-header{
          display: flex;
          justify-content: center;
          width: 100%;
          padding-top: 12px;
          padding-bottom: 12px;
          border-bottom: solid 1px #E1D4C4;
          h2{
            font-size: 16px;
            margin: 0;
            font-weight: 700;
            line-height: 24px;
          }
        }
        .card-body{
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          .project-list{
            display: flex;
            align-items: center;
            justify-content: center;
            gap: .4rem;
            color: #4a8697;
            font-size: 18px;
            font-weight: 500;
            flex-wrap: wrap;
            .project-container{
              display: flex;
              gap: .4rem;
            }
            .project{
              display: flex;
              align-items: center;
              gap: .5rem;
              div{
                display: flex;
                align-items: center;
                gap: .5rem;
              }
              svg{
                margin-top: 3px;
              }
              p{
                padding: 0;
                margin: 0;
                white-space: nowrap;
              }
            }
          }
          .project p{
            font-weight: 600 !important;
          }
          .intro{
            font-weight: 400;
            white-space: pre-line;
          }
        }
        .card-footer{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #BA8F69;
          border-radius: 0px 0px 12px 12px;
          gap: 4px;
          svg {
            margin-top: 2px;
          }
          h3 {
            font-size: 14px;
            line-height: 22px;
            font-weight: 600;
            color: white;
            margin: 0;
          }
        }
      }
      .card:nth-child(1) {
        .card-header{
          background-color: #BA8F69;
          border-radius: 12px 12px 0px 0px;
          h2{
            color:white;
          }
        }
      }
    }
  }
}

@media (max-width: 816px) {
  .project-container{
    flex-direction: column;
    gap: 0px !important;
    .project{
      flex-direction: column;
      gap: 0px !important;
    }
  }
}

@media (max-width: 580px) {
  .plan{
    .max{
      .card-block{
        .card{
          width: 100%;
          .card-header{
            h2{
              font-size: 16px;
              font-weight: 700;
            }
          }
          .card-body{
            .project-list{
              div{
                img{
                  width: 20px
                }
              }
            }
          }
        }
      }
      h2{
        font-size: 20px;
        line-height: 20px;
        font-weight: 600;
        margin: 0 0 15px 0;
      }
    }
  }
}
</style>
<script>
export default {
  data () {
    return {
      plan: [
        {
          name: '精緻方案',
          project: ['Project A.', 'Project B.'],
          intro: '逸居最受歡迎的驗屋服務! 除了全面檢測房屋品質外，更深入檢測房屋環境數值，同時也將油漆、清潔 等外觀細節納入驗屋範圍。\n\n讓您無需費心，安心將房屋品質交給逸居。',
          footer: '逸居最受歡迎的驗屋服務!'
        },
        {
          name: '標準方案',
          project: ['Project A.'],
          intro: '透過逸居上千戶的專業驗屋經驗，統整出最精華、最重要的驗屋檢測項目。 利用百萬級的高科技設備儀器，依照合約內容、圖說、施工規範、建築、機電、消防等相關法規，找出房屋潛在的未知缺陷。\n\n【 此方案不針對一般肉眼可目視及較主觀之內容檢測，如外觀細部瑕疵、油漆表面、清潔等。】'
        },
        {
          name: '團驗方案',
          intro: '此方案針對新建案預售屋，不論是透天還是大樓，向逸居提供建案名稱，即可為您整理社區內容，並提供專屬的專案報價。\n\n讓每一戶都能以寶惠的價格，享受專業的驗屋服務。'
        },
        {
          name: '中古屋方案',
          intro: '中古屋與新成屋的屋況不同，此方案專注於中古屋的特定需求，讓您在全面掌握房屋狀況的同時，每一分錢都花得更有價值。\n\n特殊需求，可向逸居諮詢客製化檢測項目，讓服務更加符合您的需求!'
        }
      ]
    }
  }
}
</script>
